module.exports = __webpack_public_path__ + "static/media/ventil.fae23f12.jpg";